// PassFirst shared UI module.
//
// Tokens (colors, typography, spacing) are the primary export today;
// shared components will land here as flows mature. See ./tokens.ts and
// docs/pm-handoff/03-design-direction.md.

export const UI_VERSION = "0.2.0";

export {
  palette,
  colors,
  darkColors,
  fontFamily,
  fontSize,
  textStyle,
  space,
  radius,
  elevation,
  layout,
} from "./tokens";

export type { SemanticColor } from "./tokens";
